{
  "title": "Rastreador de Actividad FBO",
  "comingSoonTitle": "Próximamente",
  "comingSoonDescription": "Esta función mostrará el seguimiento de actividad para cada cuenta de FBO.",
  "fboAccountsTitle": "Cuentas FBO ({{count}}):",
  "activityDataComingSoon": "Datos de actividad próximamente"
}
